import $ from "jquery";

declare var Swiper: any;

export class AnleitungSlider {

    constructor() {
        (<any>window).AnleitungSlider = this;

        $(window).on("load", function () {
            (<any>window).AnleitungSlider.initAnleitungSlider();
        });
    }

    initAnleitungSlider() {
        $(".swiper-anleitung").each(function () {
            var id = $(this).data("id");
            var swiperId = "swiper-" + id;

            var sliderAmount = $("#" + $(this).attr("id")).find(".swiper-slide").length;

            var config: any = {
                slidesPerView: 1,
                grabCursor: true,
                loop: true,
                autoHeight: true, // Höhe pro Slide anhand des Inhalts (passt sich der Bildhöhe/Textlänge an)
                navigation: { nextEl: ".swiper-button-next-" + id, prevEl: ".swiper-button-prev-" + id },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                lazy: {
                    loadPrevNext: true,
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 0
            };

            if (sliderAmount <= 1) {
                config.loop = false;
            }

            var swiperInstance = new Swiper(".swiper-anleitung#" + swiperId, config);
            swiperInstance.autoplay.stop();

            var $container = $(this);
            $container.find(".swiper-button-next").attr("aria-label", "Nächstes Bild");
            $container.find(".swiper-button-prev").attr("aria-label", "Vorheriges Bild");
            $container.find(".swiper-button-prev, .swiper-button-next").attr("role", "button");

            // Start/Stop
            var isPlaying = false;
            var toggleBtns = $container.find(".toggle-autoplay"); // ALLE Buttons in diesem Slider

            toggleBtns
                .addClass("is-paused")
                .attr("aria-label", "Autoplay starten");

            toggleBtns.on("click", function () {
                if (isPlaying) {
                    swiperInstance.autoplay.stop();
                    toggleBtns
                        .removeClass("is-playing")
                        .addClass("is-paused")
                        .attr("aria-label", "Autoplay starten");
                } else {
                    swiperInstance.autoplay.start();
                    toggleBtns
                        .removeClass("is-paused")
                        .addClass("is-playing")
                        .attr("aria-label", "Autoplay pausieren");
                }
                isPlaying = !isPlaying;
            });
        });
    }
}
